'use client';
import { Chip, MenuItem, Popover, Typography } from '@mui/material';
import { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { LabelLarge, Row } from '../../../styles';
import { useTheme } from '../../../hooks';
import CheckIcon from '@mui/icons-material/Check';

type FilterChipProps = {
    initialValue: string;
    options: string[];
    setFilterValue: (currentFilter: string) => void;
    leadingText?: string;
};

const FilterChip = ({ initialValue, options, setFilterValue, leadingText }: FilterChipProps) => {
    const theme = useTheme();

    const [currentFilter, setcurrentFilter] = useState<string>(initialValue);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const isOpen = Boolean(anchorEl);
    const id = isOpen ? 'simple-popover' : undefined;

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelection = (selection: string) => {
        setcurrentFilter(selection);
        setFilterValue(selection);
    };

    const renderArrow = () => {
        return <>{isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</>;
    };

    return (
        <Row>
            {leadingText && <LabelLarge mr={1}>{leadingText}</LabelLarge>}
            <Chip
                sx={{
                    borderRadius: '8px',
                    backgroundColor:
                        currentFilter !== initialValue
                            ? theme.colors.primaryContainer
                            : theme.colors.surface,
                    border: currentFilter !== initialValue ? 0 : null,
                    fontWeight: 500,
                    '.MuiChip-avatar': {
                        marginLeft: 1,
                        marginRight: -0.5,
                        height: '18px',
                        width: '18px'
                    }
                }}
                label={currentFilter}
                onClick={handleClick}
                variant='outlined'
                color='default'
                onDelete={handleClick}
                avatar={currentFilter !== initialValue ? <CheckIcon /> : undefined}
                deleteIcon={renderArrow()}
            />
            <Popover
                id={id}
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div style={{ padding: theme.spacing(2) }}>
                    {options.map((option, index) => (
                        <MenuItem
                            key={index}
                            value={option}
                            onClick={() => {
                                handleSelection(option);
                                handleClose();
                            }}
                        >
                            <Typography>{option}</Typography>
                        </MenuItem>
                    ))}
                </div>
            </Popover>
        </Row>
    );
};

export { FilterChip };
